if (!customElements.get('m-scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.promotion = this.querySelector('.m-promotion');
      if (!this.promotion) return;
      this.init();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('m-promotion--animated');
        const CLONE_COUNT = 10;

        for (let i = 0; i < CLONE_COUNT; i++) {
          const clone = this.promotion.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          this.appendChild(clone);
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle(
                'm-scrolling-promotion--paused',
                !entry.isIntersecting
              );
            });
          },
          { rootMargin: '50px 0px' }
        );
        
        this.observer.observe(this);
      }
    }
  }

  customElements.define('m-scrolling-promotion', ScrollingPromotion);
}
